import db from '@/plugins/dexie';
import { TOKEN, USER_STORAGE } from '@/constants/STORAGE';
import notaatt from '@/utils/notaatt';
import store from '../store';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}
export default async function conexao() {
  // Login do Usuário caso se conectou offline.
  const authToken = getSessionStorage(TOKEN, '');
  const useridnuvem = getSessionStorage(USER_STORAGE.useidnuvem, '');
  const payload = await db.usuario.where({ useidnuvem: useridnuvem }).first();
  if (!authToken) {
    try {
      const user = {
        cpf: payload.usecpf,
        password: payload.usesenha,
      };
      // Precisa de await: quem chama depende do auth:token ja estar gravado
      // (o ciclo de sync do WS monta o userId a partir dele).
      await store.dispatch('auth/authenticate', user);
    } catch (err) {
      console.log(err);
    }
  }
  notaatt();

/*   // Atualização das notas que foram emitidas enquanto offline
  const processando = await db.notafiscal.where({ nofprocessamento: 'EM PROCESSAMENTO' });
  const semcodigo = [];
  for (const item of (await processando.toArray())) {
    if (item.nofcodigoretornanfesefaz == '100') {
      await db.notafiscal.where({ id: item.id }).modify({nofprocessamento: 'EMITIDO'});
    } else if(item.nofcodigoretornanfesefaz !== '100' && item.nofcodigoretornanfesefaz) {

      await db.notafiscal.where({ id: item.id }).modify({nofprocessamento: 'ERRO'});
    } else {
      semcodigo.push(item)
    }
  }
  if(semcodigo.length > 0) {
    store.dispatch('notafiscal/verificarEmissao', { body: semcodigo });
  } */
}
